const Utils = {
  isNullOrUndefined(param) {
    if (typeof param !== 'undefined' && param) return false
    return true
  },
  isArray(a) {
    return !!a && a.constructor === Array
  },
  isObject(a) {
    return !!a && a.constructor === Object
  },
  isLocalhost() {
    return (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === ''
    )
  }
}

export const isMobile = () => window.innerWidth <= 425
export const isTablet = () => window.innerWidth <= 768
export const isDesktopOrLaptop = () => window.innerWidth >= 768
export const isBigScreen = () => window.innerWidth <= 1920
export default Utils
